import { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopBulkProductList from "../../../components/Shops/Products/BulkProductUpload";

const ShopProductBulkUploadPage = (): ReactElement => {
  return (
    <Layout>
      <ShopBulkProductList />
    </Layout>
  );
};

export default ShopProductBulkUploadPage;
